export default __webpack_public_path__ + "static/media/dom-res4.2ee1baa4.jpg";